function mask(value: string | number | undefined) {
  if (!value) {
    return (0).toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      currencyDisplay: 'code'
    }).replace('BRL', '').trim();
  }

  const numeroLimpo = String(value).replace(/\D/g, '');

  if (!numeroLimpo) {
    return (0).toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      currencyDisplay: 'code'
    }).replace('BRL', '').trim();
  }

  const numero = parseFloat(numeroLimpo) / 100;

  const numeroFormatado = numero.toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    currencyDisplay: 'code'
  }).replace('BRL', '').trim();

  return numeroFormatado;
}

function unMask(value: string | number) {
  if (typeof value === "number") {
    return value;
  }
  // Remove qualquer caractere que não seja dígito numérico
  const cleanNumber = value.replace(/\D/g, '');

  // Converte para número
  const number = parseFloat(cleanNumber) / 100;

  // Retorna o valor numérico
  return number;
}

export default {
  mask,
  unMask
}
